import { Label, TextField } from "@towersystems/roam-common-native";
import { Controller, useFormContext } from "react-hook-form";
import { View } from "react-native-ui-lib";
import { OrderItemFormValues } from "../../types";
import { useTranslation } from "../../../../../../utilities/i18n";

export const SupplierCodeFormInput = () => {
  const { control } = useFormContext<OrderItemFormValues>();
  const { t } = useTranslation("stockorder");
  return (
    <View>
      <Label required label={t("form.supplier_stock_code.label")}></Label>
      <Controller
        name="supplierCode"
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <TextField
            value={value ?? ""}
            onChangeText={onChange}
            validationMessage={error ? error.message : undefined}
            placeholder={t("form.supplier_stock_code.placeholder")}
          />
        )}
      />
    </View>
  );
};
